import React, { forwardRef } from 'react';

import { Flex, Tag, Text } from '@chakra-ui/react';
import Image from 'next/image';

import { env } from '@/env';
import { WhatsNewItem as WhatsNewItemType } from '@/types/cms/whats-new.type';

interface WhatsNewItemProps {
  item: WhatsNewItemType;
}

const WhatsNewItem: React.ForwardRefExoticComponent<WhatsNewItemProps> =
  forwardRef(({ item }) => {
    const imageData = item.image.data.attributes;

    return (
      <div>
        <Image
          src={`${env.NEXT_PUBLIC_STRAPI_URL}${imageData.url}`}
          alt={imageData.alternativeText}
          width={imageData.width}
          height={imageData.height}
        />
        <Flex
          direction="column"
          alignContent="start"
          px={{
            base: 4,
            md: 6,
          }}
          pt={{
            base: 5,
            md: 8,
          }}
          gap={5}
        >
          <Flex>
            <Tag
              px={3}
              bg="primary"
              color="backgroundPrimary"
              borderRadius={12}
              fontSize={12}
              fontWeight={600}
            >
              NEW
            </Tag>
          </Flex>

          <Flex direction="column" alignItems="start" flexWrap="wrap" gap={3}>
            <Text textAlign="start" fontSize={24} fontWeight={600}>
              {item.title}
            </Text>

            <Text textAlign="start" fontSize={14} fontWeight={500}>
              {item.description}
            </Text>
          </Flex>
        </Flex>
      </div>
    );
  });

WhatsNewItem.displayName = 'WhatsNewItem';

export { WhatsNewItem };
